/* globals $:false */

import tmpl from '../templates/definition-condition-entry.dot';

// View to edit a Field's Condition
//
// callbacks:
//
//  * `top_field_add`: Called when the user wants to add a field to the top
//  * `top_field_drop`: Called when the user drops a field in the top spot
//  * `remove`: Called when the user deletes the condition
var DefinitionConditionV = function(core, $container, callbacks){
    var _$element;
    var _$conditionLabel;
    var _$conditionField;
    var _$fields;
    var _$topInsertionPoint;

    return {
        build: function(condition, readonly) {
            _$element = $(tmpl({editable: !readonly, condition: condition}));

            _$conditionField = _$element.find(".condition-field");
            _$fields = _$element.children(".fields");
            _$conditionLabel = _$element.find(".condition-label");

            _$conditionLabel.on('click', function() {
                _$fields.toggleClass("hidden");
                $(".icon-chevron-right", _$conditionLabel).toggleClass("icon-rotate-90");
            });

            _$element.find(".remove-button").on('click', callbacks.remove);

            _$topInsertionPoint = _$element.find("li.field-insertion-point");
            _$topInsertionPoint.on('click', callbacks.top_field_add);
            _$topInsertionPoint.droppable({
                //class added to the element while something is beeing dragged
                activeClass: 'def-state-active',

                //class added to the element while something is hovering above it
                hoverClass: 'def-state-hover',

                // don't add the dropped element to parent droppables
                greedy: true,

                // called when the element is actually dropped
                drop: function(event, ui) {
                    var _$draggedElement = ui.draggable;
                    //para a li voltar à lista e não ficar com o offset do fim do drag
                    _$draggedElement.attr('style', 'position:relative;');

                    callbacks.top_field_drop(_$draggedElement);
                }
            });
        },

        getContainer: function() {
            return _$element;
        },

        focusConditionField: function() {
            _$conditionField.focus();
        },
        getCondition: function() {
            return _$conditionField.val() !== ""
                ? _$conditionField.val()
                : undefined;
        },

        expand: function() {
            _$fields.removeClass("hidden");
            $(".icon-chevron-right", _$conditionLabel).addClass("icon-rotate-90");
        },
        collapse: function() {
            _$fields.addClass("hidden");
            $(".icon-chevron-right", _$conditionLabel).removeClass("icon-rotate-90");
        },

        clearErrors: function() {
            _$conditionField.removeClass("error");
            _$element.find('.condition-error').html("");
        },
        showErrors: function(errors) {
            _$conditionField.addClass("error");
            _$element.find('.condition-error')
                .html(errors
                    .map((e) => (e.part ? `<code>${e.part}</code>:` : '') + e.errorMsg)
                    .join('<br/>')
                );
        },

        addTopField: function(fieldP) {
            _$fields.append(fieldP.content());

            fieldP.focus();
        },
        addField: function(fieldP) {
            _$fields.append(fieldP.content());
        },

        remove: function() {
            _$element.remove();
        }
    }

};

export default DefinitionConditionV;
